export const authHeader = (): { Authorization?: string } | null =>
    sessionStorage.getItem('token') ? {Authorization: `Bearer ${sessionStorage.getItem('token')}`} : null
